import {useContext} from "react";
import ConfigurationsService from "../services/ConfigurationsService";
import {ConfigDispatch} from "../context/ConfigContext";
import {TextSectionsDispatch} from "../context/TextSectionsListContext";
import {EditTypeDispatch} from "../context/EditTypeContext";
import WCData from "../services/WCData";
import {convertMMtoPx} from "../services/helpers";

const confService = new ConfigurationsService();
const wcData = new WCData();
const fontsData = await wcData.getFontsData();
let confFromUrl = null;

const urlParams = new URLSearchParams(window.location.search);
const uuid = urlParams.get('uuid');
if (uuid) {
    confFromUrl = await confService.getConfigurationForNotLoggedInUsers(uuid);
    //console.log('UUID from URL:', confFromUrl);
}

function InitConfig() {
    const configDispatch = useContext(ConfigDispatch);
    const textSectionsDispatch = useContext(TextSectionsDispatch);
    const editTypeDispatch = useContext(EditTypeDispatch);

    const fetchFontsData = async () => {
        return new Promise((resolve) => {
            if (fontsData.fonts.length !== 0) {
                //console.log('FETCH FONTS DATA', fontsData);
                //set font data
                configDispatch({
                    'type': 'set',
                    'payload': {
                        fontsData: fontsData.fonts,
                    }
                });
                //set default font
                configDispatch({
                    'type': 'changeFontFamily',
                    'payload': fontsData.fonts[0].fontFamily
                });
            }
            resolve();
        });
    }

    const addTextSections = async (textSections) => {
        return new Promise((resolve) => {
            textSections.map((section, index) => {
                textSectionsDispatch({
                    type: 'addTextSection',
                    payload: {
                        position: {
                            x: section.position.x,
                            y: section.position.y,
                        },
                        value: section.value,
                        fontSize: section.fontSize,
                        letterSpacing: section.letterSpacing,
                        rawContent: section.rawContent,
                        fontSizeValue: section.fontSizeValue,
                        index: index,
                    }
                });
            });
            resolve();
        });
    }

    const setTypeAsEdit = async (id, name) => {
        return new Promise((resolve) => {
            editTypeDispatch({
                type: 'setId',
                payload: id
            });
            editTypeDispatch({
                type: 'setName',
                payload: name
            });
            editTypeDispatch({
                type: 'setType',
                payload: 'edit'
            });
            resolve();
        });
    }

    const setConfigData = async (fontConfig) => {
        return new Promise((resolve) => {
            configDispatch({
                type: 'set',
                payload: fontConfig
            });
            resolve();
        });
    }

    const loadConfigurationFromUrl = async (item) => {
        //console.log('LOAD CONF FROM URL', item);
        const fontConfig = item.fontConfig;
        const textSections = item.textSections;
        const id = item.id;
        const name = item.name;
        //set config data
        await setConfigData(fontConfig);
        //set text sections
        await addTextSections(textSections);
        //set edit type id ,and name
        await setTypeAsEdit(id, name);
        confFromUrl = null; // Clear confFromUrl after loading
    }

    const init = async () => {
        await fetchFontsData();
        if(confFromUrl) {
            await loadConfigurationFromUrl(confFromUrl.data);
        }
    }

    init();

    return (<div data-init></div>);
}

export default InitConfig;
